import React, { useState } from 'react';
import type { FC, ReactNode } from 'react';

import { BrandPanel } from '../BrandPanel/BrandPanel';
import { QrModal } from '../QrModal/QrModal';
import styles from './AuthShell.module.scss';

interface AuthShellProps {
    title: string;
    lead?: ReactNode;
    children: ReactNode;
    footer?: ReactNode;
}

export const AuthShell: FC<AuthShellProps> = ({ title, lead, children, footer }) => {
    const [qrOpen, setQrOpen] = useState(false);

    return (
        <>
            <main className={styles.page}>
                <BrandPanel onOpenQr={() => setQrOpen(true)} />

                <section className={styles.panel}>
                    <div className={styles.card}>
                        <h1 className={styles.title}>{title}</h1>
                        {lead && <p className={styles.lead}>{lead}</p>}

                        {children}

                        {footer && <div className={styles.footer}>{footer}</div>}
                    </div>
                </section>
            </main>

            <QrModal open={qrOpen} onClose={() => setQrOpen(false)} />
        </>
    );
};